<template>
  <span class="loader"></span>
</template>

<script>
export default {
  name: "SpinnerLoader"
};
</script>

<style scoped>
.loader {
  display: inline-block;
  padding: 6px;
  border-radius: 100%;
  background:
    radial-gradient(
      circle,
      rgba(45, 204, 205, 1) 0%,
      rgba(0, 68, 129, 1) 60%,
      rgba(0, 68, 129, 1) 100%
    ),
    #004481;
  background-position: center -30px;
  background-repeat: no-repeat;
  -webkit-animation: rotar 1.1s infinite linear;
  animation: rotar 1.1s infinite linear;
}

.loader::after {
  content: "";
  border-radius: 100%;
  display: block;
  background-color: white;
  width: 42px;
  height: 42px;
}

@-webkit-keyframes rotar {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotar {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
